//
//
//
//
//
//

export default {
  name: 'IChecked',
  components: {
    index: function index() {
      return import('./index');
    }
  }
};